<template>
  <div class="full-width-height">
    <elopement-alerts v-if="showElopementAlerts" class="westchester"/>
    <object-alerts v-else/>
  </div>
</template>

<script>
import ObjectAlerts from './ObjectAlerts.vue'
import ElopementAlerts from './ElopementAlerts.vue'
import { mapGetters, mapActions } from 'vuex'
import { DomainPreferences, AlertsSource } from '@/libraries/permissions/domainPreferences'

export default {
  name: 'EventsTimeline',
  components: {
    ObjectAlerts,
    ElopementAlerts,
  },
  computed: {
    ...mapGetters({
      currentDomain: 'currentDomain',
      preferences: 'preferences',
    }),
    showElopementAlerts () {
      return this.preferences[DomainPreferences.ALERTS_SOURCE] === AlertsSource.FACES
    },
  },
  methods: {
    ...mapActions({
      refreshAlerts: 'elopementRisks/checkMostRecent',
    }),
  },
}
</script>

<style scoped>
.full-width-height {
  height: 100%;
  width: 100%;
}

.filter.banner {
  height: 7rem;
}

.sticky.header {
  background-color: rgba(0, 0, 0, 0);
  z-index: 10000;
  position: absolute;
  top: 5rem;
  left: 5rem;
  width: 90%;
  display: none;
}

.westchester {
  padding-top: 7rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow-y: auto;
}
</style>
